/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopesRegular from './envelopes-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopesRegular {...validProps} />;
}
SvgComponent.iconName = 'envelopesRegular';

export const EnvelopesRegularIcon = svgIconWrapper(SvgComponent);
